import React from "react";
import { useHistory, withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { IconButton, Button, Snackbar, useTheme } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import MenuIcon from "@material-ui/icons/Menu";
import { ReactComponent as TwitterIcon } from "../../assets/twitter.svg";
import { ReactComponent as TelegramIcon } from "../../assets/telegram.svg";
import { ReactComponent as MediumIcon } from "../../assets/medium.svg";
import { ReactComponent as GitbookIcon } from "../../assets/gitbook.svg";

import dexToolsIcon from "../../assets/icons/dextools.png";
import baseScanIcon from "../../assets/icons/basescan.png";

import HeaderLink from "./link";
import RedirectModal from "./modal";
import ThemeModal from "./modal/themeModal";

import GlobalStore from "../../stores";

import BuyModalBox from "./components/modal";
import starterLogo from "../../assets/starter-logo.png";

import {
  ERROR,
  STAKE_RETURNED,
  UNSTAKE_RETURNED,
  toFixed,
  COLLECT_FUND_RETURNED,
  CANCEL_PRESALE_RETURNED,
  SEND_UNSOLD_TOKENS_RETURNED,
  WRITE_RETURNED,
  defaultBuyUrls,
  SWAP,
  SWAP_RETURNED,
  GET_BALANCES_RETURNED,
  GET_SWAP_INFO_RETURNED,
} from "../../constants";
import ThemeSwitcher from "./components/ThemeSwitcher";
import ConnectWalletButton from "../connectWalletButton";
import { useAccount } from "../../contexts/AccountContext";

const emitter = GlobalStore.emitter;
const Store = GlobalStore.store;
const dispatcher = GlobalStore.dispatcher;

const styles = (theme) => ({
  root: {
    display: "flex",
    height: "100%",
    width: "100%",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    [theme.breakpoints.up("md")]: {
      maxWidth: "100vw",
      overflow: "hidden",
    },
  },
  headerContainer: {
    display: "flex",
    width: "100vw",
    height: "90px",
    background: theme?.colors?.header?.backgroundColor,
  },
  headerInnerContainer: {
    display: "flex",
    width: "100vw",
    height: "80px",
    boxShadow: "0px 3px 3px #0B193B24",

    alignItems: "center",
    justifyContent: "flex-start",
    padding: "16px 2rem",

    [theme.breakpoints.up("md")]: {
      gap: "1rem",
      padding: "16px 2rem",
    },

    [theme.breakpoints.up("lg")]: {
      gap: "2rem",
      padding: "16px 6rem",
    },
  },
  bodyContainer: {
    width: "100%",
    minHeight: "calc(100vh - 90px)",
    height: "auto",
    background: theme?.colors?.header?.bodyContainer,
    // backgroundImage: theme?.backgroundImage,
    backgroundSize: "cover",
    [theme.breakpoints.up("md")]: {
      overflow: "auto",
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  footerContainer: {
    display: "flex",
    width: "100%",
    background: theme?.colors?.footer?.backgroundColor,
    // borderTop: "1px solid #393939",

    [theme.breakpoints.up("md")]: {
      height: "120px",
    },

    alignItems: "center",
    justifyContent: "center",
  },
  footerInnerContainer: {
    display: "flex",
    height: "100%",
    width: "100%",
    padding: "16px 6rem",
    backgroundSize: "cover",
    alignItems: "center",
    boxShadow: "0px -1px 2px #0B193B24",
    justifyContent: "space-between",
    flexDirection: "column",
    gap: "16px",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  walletContainer: {
    height: "50px",
    maxWidth: "1280px",
    display: "none",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.up("md")]: {
      display: "flex",
      gap: "0.7rem",
    },
  },
  logoContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: "0px",
  },
  linkContainer: {
    display: "none", // todo: check
    alignItems: "center",
    justifyContent: "space-between",

    width: "100%",

    [theme.breakpoints.up("md")]: {
      display: "flex",
      gap: "1rem",
    },
    [theme.breakpoints.up("lg")]: {
      justifyContent: "flex-end",
      gap: "4rem",
    },
    [theme.breakpoints.up("xl")]: {
      gap: "6rem",
    },
  },
  actionContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  logoButton: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
  },
  logoText: {
    color: theme?.colors?.header?.text,
    letterSpacing: ".025em",
    fontSize: "1.5rem",
    fontWeight: "bold",
  },
  logoBoldText: {
    color: theme?.colors?.header?.boldBrownText,
    letterSpacing: ".025em",
    fontSize: "1.5rem",
    fontWeight: "bold",
  },
  walletButton: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "solid 2px" + theme?.colors?.wallet?.buttonBackground,
    textTransform: "capitalize",
    height: "40px",
    color: theme?.colors?.wallet?.buttonText,
    "&:hover": {
      border: "solid 2px" + theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonBackgroundHover,
    },
    fontFamily: "Poppins",
    letterSpace: "0px",

    width: "130px",
    padding: "8px",
    whiteSpace: "nowrap",
  },
  createButton: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
      border: "solid 2px" + theme?.colors?.wallet?.buttonBackgroundHover,
    },

    border: "solid 2px" + theme?.colors?.wallet?.buttonBackground,
    height: "40px",
    width: "130px",
    padding: "8px",

    fontFamily: "Poppins",
    letterSpace: "0px",
    whiteSpace: "nowrap",
  },
  buyTokenButton: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    height: "40px",
    width: "150px",
    padding: "8px 16px",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonTextSecondary,
    },
  },
  applyButton: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "solid 2px" + theme?.colors?.wallet?.buttonBackground,
    color: theme?.colors?.wallet?.buttonTextSecondary,
    textTransform: "capitalize",
    height: "40px",
    width: "240px",
    padding: "8px 16px",
    marginBottom: "16px",
    "&:hover": {
      backgroundColor: theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonText,
    },
  },
  certifiedButton: {
    borderRadius: "20px",
    boxShadow: "0 1px 2px 0 rgba(0,0,0,.05)",
    backgroundColor: "transparent",
    border: "solid 2px" + theme?.colors?.wallet?.buttonBackground,
    textTransform: "capitalize",
    height: "40px",
    width: "130px",
    color: theme?.colors?.wallet?.buttonText,
    padding: "8px",
    "&:hover": {
      border: "solid 2px" + theme?.colors?.wallet?.buttonBackgroundHover,
      color: theme?.colors?.wallet?.buttonBackgroundHover,
    },
    fontFamily: "Poppins",
    letterSpace: "0px",
    whiteSpace: "nowrap",
  },
  footerOplsContainer: {
    display: "flex",
    alignItems: "center",
  },
  oplsBalance: {
    color: theme?.colors?.footer?.tokenBalance,
    fontSize: "16px",
    margin: "0 32px 0 8px",
  },

  buttonLabel: {
    fontWeight: "bold",
    fontSize: "0.875rem",
    lineHeight: "1.25rem",
  },
  openMenuButtonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
    position: "absolute",
    right: "2rem",
    top: "18px",
  },
  menuButton: {
    padding: "6px",
  },
  menuIcon: {
    width: "30px",
    height: "30px",
    color: theme?.colors?.header?.menuButton,
  },
  balanceInfo: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    fontSize: "15px",
    lineHeight: "18px",
    color: theme?.colors?.header?.balanceText,
  },
  bnbBalance: {
    fontSize: "15px",
    lineHeight: "18px",
    whiteSpace: "nowrap",
    color: theme?.colors?.header?.balanceValue,
    cursor: "pointer",
  },
  footerLinks: {
    flex: 1,
    display: "flex",
    width: "100%",

    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  footerLinksText: {
    lineHeight: "20px",
    // color: "#fff",
    color: theme?.colors?.footer?.brandName,
    fontWeight: "bold",
    letterSpacing: "0px",
    margin: "0 0 6px 0",
    textAlign: "center",
    fontSize: "16px",
    marginBottom: "6px",

    [theme.breakpoints.up("md")]: {
      textAlign: "left",
      marginBottom: "0px",
      fontSize: "12px",
    },
  },
  footerLinksContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "16px",

    [theme.breakpoints.up("md")]: {
      marginLeft: "38px",
      marginTop: "0px",
    },
  },
  footerRight: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  icon: {
    color: theme?.colors.poolCard?.linkIcon,
  },
  link: {
    padding: "0 5px 0 5px",
    textDecoration: "none",
    "&:hover": {
      opacity: 0.8,
    },
    [theme.breakpoints.up("sm")]: {
      padding: "0 10px 0 10px",
    },
  },
  certifiedBadge: {
    width: "30px",
    height: "30px",
    position: "absolute",
    left: "3px",
    top: "3px",
  },
  starterLtdText: {
    color: "#A0A0A0",
    fontSize: "10px",
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
    },
  },
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Header({ classes, children }) {
  const history = useHistory();
  const navUrl = history?.location?.pathname?.toLowerCase() || "";
  const nav = (screen) => {
    history.push("/" + screen);
  };
  const [modalOpen, setModalOpen] = React.useState(false);
  const [themeModalOpen, setThemeModalOpen] = React.useState(false);

  const [isBuyModalShown, showBuyModal] = React.useState(false);
  const [swapPrice, setSwapPrice] = React.useState(0);
  const [swapTokenAmount, setSwapTokenAmount] = React.useState(0);
  const [buidlTokenAmount, setBuidlTokenAmount] = React.useState(0);

  const [buidlTokenPrice, setBuidlTokenPrice] = React.useState(0);

  const [errorMessage, setErrorMessage] = React.useState(null);
  const [infoMessage, setInfoMessage] = React.useState(null);
  React.useState(0);

  const { account } = useAccount();

  const theme = useTheme();

  React.useEffect(() => {
    getBalancesReturned();
    fetchSwapData();
    emitter.on(ERROR, errorReturned);

    emitter.on(STAKE_RETURNED, stakeReturned);
    emitter.on(UNSTAKE_RETURNED, unstakeReturned);

    emitter.on(GET_BALANCES_RETURNED, () => {
      getBalancesReturned();
    });
    emitter.on(GET_SWAP_INFO_RETURNED, () => {
      fetchSwapData();
    });

    emitter.on(COLLECT_FUND_RETURNED, collectFundReturned);
    emitter.on(CANCEL_PRESALE_RETURNED, cancelPresaleReturned);
    emitter.on(SEND_UNSOLD_TOKENS_RETURNED, sendUnsoldTokensReturned);
    emitter.on(WRITE_RETURNED, writeReturned);

    emitter.on(SWAP_RETURNED, swapReturned);

    return () => {
      emitter.removeListener(ERROR, errorReturned);
      emitter.removeListener(STAKE_RETURNED, stakeReturned);
      emitter.removeListener(UNSTAKE_RETURNED, unstakeReturned);
      emitter.removeListener(GET_BALANCES_RETURNED, () => {
        getBalancesReturned();
      });
      emitter.removeListener(GET_SWAP_INFO_RETURNED, () => {
        fetchSwapData();
      });

      emitter.removeListener(COLLECT_FUND_RETURNED, collectFundReturned);
      emitter.removeListener(CANCEL_PRESALE_RETURNED, cancelPresaleReturned);
      emitter.removeListener(
        SEND_UNSOLD_TOKENS_RETURNED,
        sendUnsoldTokensReturned
      );
      emitter.removeListener(WRITE_RETURNED, writeReturned);
      emitter.removeListener(SWAP_RETURNED, swapReturned);
    };
  }, []);

  const getBalancesReturned = () => {
    const buidlPrice = Store.getStore("buidlPrice");
    const buidlBalance = Store.getStore("buidlBalance");
    setBuidlTokenPrice(buidlPrice);
    setBuidlTokenAmount(toFixed(buidlBalance, 18, 3));
  };

  const collectFundReturned = (transactionHash) => {
    setInfoMessage("Collect Fund Success! TransactionHash: " + transactionHash);
  };

  const cancelPresaleReturned = (transactionHash) => {
    setInfoMessage(
      "CANCEL PRESALE Success! TransactionHash: " + transactionHash
    );
  };

  const sendUnsoldTokensReturned = (transactionHash) => {
    setInfoMessage(
      "SEND UNSOLD TOKENS Success! TransactionHash: " + transactionHash
    );
  };

  const closeNavModal = () => {
    setModalOpen(false);
  };

  const errorReturned = (_error) => {
    const message = `${_error}`;
    if (!message.includes("Invalid JSON")) {
      setErrorMessage(
        (message && message.length > 0 && message.slice(0, 60) + "...") ||
          "Error"
      );
    }
  };

  const onSwap = (amount, amountOut, direction) => {
    const minAmountOut = (parseFloat(amountOut) * 995) / 1000;

    dispatcher.dispatch({
      type: SWAP,
      content: {
        amount: amount,
        amountOut: minAmountOut,
        direction,
      },
    });
  };

  const fetchSwapData = () => {
    const swapData = Store.getStore("swapData");

    setSwapTokenAmount(
      toFixed(swapData.swapTokenBalance, swapData.swapTokenDecimals, 3)
    );
    setSwapPrice(toFixed(swapData.swapPrice, 18, 3));
  };

  const stakeReturned = (transactionHash) => {
    setInfoMessage("Stake Success! TransactionHash: " + transactionHash);
  };

  const unstakeReturned = (transactionHash) => {
    setInfoMessage("Unstake Success! TransactionHash: " + transactionHash);
  };

  const writeReturned = (transactionHash) => {
    setInfoMessage("Write Success! TransactionHash: " + transactionHash);
  };

  const swapReturned = (transactionHash) => {
    setInfoMessage("Successfully swapped! TransactionHash: " + transactionHash);
  };

  return (
    <div className={classes.root}>
      {errorMessage && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={true}
          autoHideDuration={4000}
          onClick={() => {
            setErrorMessage(false);
          }}
          onClose={() => {
            setErrorMessage(false);
          }}
        >
          <Alert severity="error">{errorMessage}</Alert>
        </Snackbar>
      )}
      {infoMessage && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={true}
          autoHideDuration={6000}
          onClose={() => {
            setInfoMessage(false);
          }}
        >
          <Alert severity="info">{infoMessage}</Alert>
        </Snackbar>
      )}
      <div className={classes.headerContainer}>
        <div className={classes.headerInnerContainer}>
          <div className={classes.logoContainer}>
            <button
              type="button"
              className={classes.logoButton}
              onClick={() => {
                nav("home");
              }}
            >
              <img src={starterLogo} alt="logo" style={{ height: "45px" }} />
            </button>
          </div>

          <div className={classes.linkContainer}>
            <HeaderLink
              screenType="DESKTOP"
              text="Projects"
              to="/pools"
              selected={navUrl.includes("pools")}
            />
            <HeaderLink
              screenType="DESKTOP"
              text="Stake"
              to="/staking"
              selected={navUrl.includes("staking")}
            />

            <HeaderLink
              screenType="DESKTOP"
              text="Research"
              to="/voting"
              selected={navUrl.includes("voting")}
            />
            <HeaderLink
              screenType="MOBILE"
              text="Locker"
              to="https://locker.starter.xyz/"
              externalLink={true}
            />

            <HeaderLink
              screenType="DESKTOP"
              text="About"
              to={theme.guide}
              externalLink={true}
            />

            <div className={classes.walletContainer}>
              <Button
                classes={{
                  root: classes.certifiedButton,
                  label: classes.buttonLabel,
                }}
                onClick={() => {
                  window.open(
                    "https://form.typeform.com/to/NPvV8s53",
                    "_blank"
                  );
                }}
              >
                Get Certified
              </Button>
              <Button
                classes={{
                  root: classes.createButton,
                  label: classes.buttonLabel,
                }}
                onClick={() => {
                  history.push("/create");
                }}
              >
                Create Pool
              </Button>

              <ConnectWalletButton />

              <ThemeSwitcher />
            </div>
          </div>

          <div className={classes.openMenuButtonContainer}>
            <IconButton
              aria-label="menu"
              classes={{ root: classes.menuButton }}
              onClick={() => {
                setModalOpen(true);
              }}
            >
              <MenuIcon className={classes.menuIcon} />
            </IconButton>
          </div>
        </div>
      </div>
      <div className={classes.bodyContainer}>
        {children}
        <div className={classes.footerContainer}>
          <div className={classes.footerInnerContainer}>
            <div className={classes.footerLinks}>
              <div>
                <p className={classes.footerLinksText}>Starter Labs</p>
                <div className={classes.starterLtdText}>
                  © 2021 - {new Date().getFullYear()}
                </div>
              </div>
              <div className={classes.footerLinksContainer}>
                <a
                  href="https://t.me/starterlabshq"
                  className={classes.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TelegramIcon
                    className={classes.icon}
                    style={{ width: "24px", height: "24px" }}
                  />
                </a>
                <a
                  href="https://twitter.com/starterlabshq"
                  className={classes.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <TwitterIcon
                    className={classes.icon}
                    style={{ width: "24px", height: "24px" }}
                  />
                </a>
                <a
                  href="https://starterlabs.medium.com/"
                  className={classes.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <MediumIcon
                    className={classes.icon}
                    style={{ width: "24px", height: "24px" }}
                  />
                </a>

                <a
                  href="https://docs.starter.xyz"
                  className={classes.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <GitbookIcon
                    className={classes.icon}
                    style={{ width: "24px", height: "24px" }}
                  />
                </a>

                <a
                  href="https://www.dextools.io/app/en/base/pair-explorer/0xcdbe83ca99d76f47f69314860f4eb52c2abaab9c"
                  className={classes.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={classes.icon}
                    src={dexToolsIcon}
                    alt="DexTools Explorer"
                    style={{ width: "24px", height: "24px" }}
                  />
                </a>

                <a
                  href="https://basescan.org/token/0xdadc4f8e9d8d37294de0e02a2ce8cc0c90a4f6c2"
                  className={classes.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className={classes.icon}
                    alt="BUIDL at Base Scan"
                    src={baseScanIcon}
                    style={{ width: "24px", height: "24px" }}
                  />
                </a>
              </div>
            </div>

            <div className={classes.footerOplsContainer}>
              <img
                src={theme.logoImage}
                alt="logo"
                style={{ width: "27px", height: "24px" }}
              />
              {/* todo: get BUIDL balance */}
              <p className={classes.oplsBalance}>{buidlTokenPrice}</p>
              <Button
                classes={{
                  root: classes.buyTokenButton,
                  label: classes.buttonLabel,
                }}
                onClick={() => {
                  showBuyModal(true);
                }}
              >
                Get BUIDL
              </Button>
            </div>
          </div>
        </div>
      </div>

      <RedirectModal
        closeModal={closeNavModal}
        modalOpen={modalOpen}
        account={account}
      />

      <ThemeModal
        modalOpen={themeModalOpen}
        closeModal={() => {
          setThemeModalOpen(false);
        }}
      />

      <BuyModalBox
        modalOpen={isBuyModalShown}
        closeModal={() => {
          showBuyModal(false);
        }}
        bnbBalance={swapTokenAmount}
        buidlBalance={buidlTokenAmount}
        price={swapPrice}
        onSwap={onSwap}
        account={account}
        url={defaultBuyUrls[theme?.type]}
      />
    </div>
  );
}

export default withRouter(withStyles(styles)(Header));
